<template>
  <div class="material_box">
    <ul>
      <li
        v-for="(item, index) in data.data"
        :key="index">
        <input
          :id="item.id"
          :name="radio"
          :value="item.id"
          v-model="radio"
          class="material_box_radio"
          type="radio"
          @change="!isMul &&checked(item.url,item)">
        <label
          :for="item.id"
          :class="{'is-mul':isMul, select: radioMul.includes(item.id)}"
          @click="isMul && handleSelect(item)"
          @dblclick="!isMul && changeFile(item.url,item)">
          <img
            v-if="id === 'image'"
            :src="item.url" >
          <p v-else>
            {{ item.name }}
          </p>
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "FileList",
  props: {
    data: {
      type: Object,
      default: null,
    },
    id: {
      type: String,
      required: true,
    },
    // 是否多选
    isMul: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      radio: "",

      radioMul: [], // 保存多选id
      urls: [], // 保存多选路径
      items: [], // 保存多选选项
    };
  },
  methods: {
    // 多选情况下 选中或取消选中
    handleSelect(item) {
      console.log('select', item.id);
      if (!this.radioMul.includes(item.id)) {
        this.radioMul.push(item.id);
        this.urls.push(item.url);
        this.items.push(item);
      } else {
        let index = -1;
        this.radioMul.map((v, i) => {
          if (`${v}` === `${item.id}`) {
            index = i;
          }
        });
        this.radioMul.splice(index, 1);
        this.urls.splice(index, 1);
        this.items.splice(index, 1);
      }

      this.$emit("checked", this.urls, this.items);
    },
    checked(url, item) {
      this.$emit("checked", url, item);
    },
    changeFile(url, item) {
      console.log(url);
      this.$emit("changeFile", url, item);
    },
    // 清除所有状态
    clearAll() {
      this.radio = '';
      this.radioMul = [];
      this.urls = [];
      this.items = [];
    },
  },
};
</script>

<style scoped>
.material_box ul:after{
        content: ".";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
        font-size: 0;
}
.material_box ul li{
    display: block;
    width: 150px;
    height: 150px;
    line-height: 150px;
    overflow: hidden;
    float: left;
    margin-right: 14px;
    margin-bottom: 10px;
    box-sizing: border-box;
    border-radius: 8px;
    text-align: center;
}
.material_box ul li label{
    border: 2px dashed #ebebeb;
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
    cursor: pointer;
}
.material_box ul li img{
    max-width: 100%;
    max-height: 100%;
    display: inline-block;
    vertical-align: middle;
}
.material_box_radio{
    display: none;
}
.material_box .is-mul{
  border: none !important;
}
.material_box .is-mul.select{
  border: 2px dashed #20a0ff !important;
}
.material_box_radio:checked + label {
    border: 2px dashed #20a0ff;
}
.material_box ul li p{
    line-height: 20px;
    margin-top: 60px;
}
</style>
